module.exports = __webpack_public_path__ + "static/media/5.69b97736.jpg";